import React, { useEffect, useRef, useState, useMemo } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useAppContext } from '../context/AppContext';

function SchemaBuilder({ setPreviewMode, agentTokenId, isVisible }) {

    const { selectedOrganization, selectedProject } = useAppContext();
    const [pluginReady, setPluginReady] = useState(false);
    const iframeRef = useRef(null);

    const schema_builder_plugin_url = window.__ENV__.EXTRACTION_SCHEMA_BUILDER_PLUGIN_URL;
    const appflyte_backend_url = window.__ENV__.APPFLYTE_BACKEND_URL;
    const appflyte_project_id = selectedProject?.payload?.__auto_id__;
    const appflyte_organization_id = selectedOrganization?.payload?.__auto_id__;

    const pluginInitData = useMemo(() => {
        if (!agentTokenId || !appflyte_project_id || !appflyte_organization_id) {
            return null;
        }
        return {
            appflyte_backend_url,
            appflyte_agent_api_token: agentTokenId,
            appflyte_organization_id,
            appflyte_project_id
        };
    }, [agentTokenId, appflyte_project_id, appflyte_organization_id, appflyte_backend_url]);

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.origin !== schema_builder_plugin_url) return;

            if (event.data?.type === "PLUGIN_READY") {
                console.log("Plugin ready");
                setPluginReady(true);
            }

            if (event.data?.type === "PLUGIN_BACK_CLICKED") {
                setPreviewMode("document");
            }
        };
        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, []);

    useEffect(() => {
        if (!pluginReady || !pluginInitData) return;
        iframeRef.current?.contentWindow?.postMessage(
            {
                type: "PLUGIN_INIT",
                payload: pluginInitData,
            },
            schema_builder_plugin_url
        );
    }, [pluginReady, pluginInitData]);

    return (
        <Box sx={{ height: "100vh", width: "100%", position: "relative", display: isVisible ? "block" : "none" }}>
            {!pluginReady && (
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#fff",
                        zIndex: 10,
                        flexDirection: "column",
                        gap: 2
                    }}
                >
                    <CircularProgress />
                    <Box>Loading Schema Builder...</Box>
                </Box>
            )}

            <iframe
                ref={iframeRef}
                src={schema_builder_plugin_url}
                title="Ameya Plugin"
                style={{ width: "100%", height: "100%", border: "none" }}
            />
        </Box>
    );
}

export default SchemaBuilder;
